import "../assets/Popup.css";
import { defineComponent as C, ref as w, computed as l, onUpdated as K, onMounted as L, openBlock as c, createElementBlock as x, unref as A, createBlock as M, resolveDynamicComponent as I, mergeProps as T } from "vue";
import { a as e, b as d, A as B } from "./maps.ChaVcqWI.js";
import { u as P, h as q } from "./Text.vue_vue_type_style_index_0_lang.D1poo19_.js";
import { n as D, u as F } from "./useStore.BHVfM1RP.js";
import { r as H } from "./useModal.CgbJKM9V.js";
import { _ as N, C as R, a as V, b as j, c as E, d as G, e as U, f as W, g as z, h as J, i as O, j as Q } from "./StickyImage.vue_vue_type_style_index_0_lang.KN-JYdxr.js";
import { p as m } from "./parseToolData.o66wWUUl.js";
const X = ["data-builder-mode", "data-device", "data-content-alignment", "data-layout-kind", "data-text-direction", "aria-label"], it = /* @__PURE__ */ C({
  __name: "Popup",
  props: {
    tool: {},
    context: {}
  },
  emits: [
    "hidden"
  ],
  setup(u, { expose: p, emit: f }) {
    const _ = {
      [e.Circular]: N,
      [e.CustomImage]: R,
      [e.Fullscreen]: V,
      [e.FullscreenMini]: j,
      [e.LowerNotification]: E,
      [e.NotificationTab]: G,
      [e.Sidebar]: U,
      [e.SideGradient]: W,
      [e.Square]: z,
      [e.SquareImage]: J,
      [e.Sticky]: O,
      [e.StickyImage]: Q
    }, o = u, y = f, i = D(m({
      ...o,
      toolKind: d.Layer
    })), r = w(), g = l(() => {
      const {
        language: t,
        deviceViewport: a
      } = o.context, {
        content: {
          modules: n
        },
        settings: {
          layout: s
        }
      } = o.tool, b = P(n), k = q(n);
      return {
        language: t,
        device: a,
        steps: b,
        hasSteps: k,
        layout: s
      };
    }), h = l(() => {
      var a;
      if (!o.tool.settings.layout)
        return null;
      const t = (a = o.tool.settings.layout) == null ? void 0 : a.type;
      return _[t];
    });
    function v() {
      var t;
      (t = r.value) == null || t.show();
    }
    function S() {
      var t;
      (t = r.value) == null || t.hide();
    }
    K(() => {
      F(m({
        ...o,
        toolKind: d.Layer
      }));
    }), L(() => {
      i.handlers.callHandler(B.Show);
    });
    function $() {
      i.handlers.reset(), H(), y("hidden");
    }
    return p({
      show: v,
      hide: S
    }), (t, a) => {
      var n, s;
      return c(), x("div", {
        class: "thn--tool thn--tool-popup",
        role: "dialog",
        "data-builder-mode": t.context.builderMode,
        "data-device": t.context.deviceViewport,
        "data-content-alignment": (n = t.tool.settings.layout) == null ? void 0 : n.contentAlignment,
        "data-layout-kind": (s = t.tool.settings.layout) == null ? void 0 : s.type,
        "data-text-direction": A(i).rtl ? "rtl" : "ltr",
        "aria-modal": "true",
        "aria-label": o.tool.name
      }, [
        (c(), M(I(h.value), T({
          ref_key: "componentRef",
          ref: r
        }, g.value, { onAfterLeave: $ }), null, 16))
      ], 8, X);
    };
  }
});
export {
  it as _
};
//# sourceMappingURL=Popup.vue_vue_type_style_index_0_lang.9IE0RkBX.js.map
